import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';

class ClassRoomMenu extends Component {
  renderMenu(){
    let contenidos = this.props.modulo.contenidos.map((cont)=>{
      return (
        <a key={`cont${cont.id}`}
          onClick={()=>this.props.abrirContenido(cont)} >
          {cont.titulo} {
            this.props.leidos!==null && this.props.leidos[cont.id]==="1" ?
            <i className="fas fa-check-circle green" /> : ""
          }
        </a>
      );
    });
    let volver = (
      <Link
        key={"volverBtnClassroom"}
        to={`/curso/${this.props.modulo.idcurso}`} >
        Volver al Curso
      </Link>
    );
    return [...contenidos, volver];
  }

  render(){
    return (
      <div id="custom-side-nav" className="sidenav">
        <a className="closebtn" onClick={(evt)=>this.closeNav()}>&times;</a>
        <span className="tittle">CEIS > {this.props.modulo.nombre}</span>
        {this.renderMenu()}
      </div>
    );
  }


  /* FOR THE SIDE NAV*/
  /* Set the width of the side navigation to 250px and the left margin of the
    page content to 250px and add a black background color to body */
  openNav() {
    document.getElementById("custom-side-nav").style.width = "350px";
    document.getElementById("non-side-nav").style.marginLeft = "350px";
  }

  /* Set the width of the side navigation to 0 and the left margin of the page
    content to 0, and the background color of body to white */
  closeNav() {
    document.getElementById("custom-side-nav").style.width = "0";
    document.getElementById("non-side-nav").style.marginLeft = "0";
  }
}

function mapStateToProps({ modulo, usuario, curso, leidos }) {
  return { modulo, usuario, curso, leidos };
}

export default connect(mapStateToProps)(ClassRoomMenu);



// WEBPACK FOOTER //
// ./src/containers/classroom_menu.js